<template>
	<div class="form-signup">
		<b-form @submit.prevent="submit">
			<b-form-group label="Name" label-for="name">
				<b-form-input
					id="name"
					v-model="form.name"
					type="text"
					required
					placeholder="Lady Gaga"
				></b-form-input>
			</b-form-group>
			<b-form-group label="Email" label-for="email">
				<b-form-input
					id="email"
					v-model="form.email"
					type="email"
					required
					placeholder="me@acme.com"
				></b-form-input>
				<small class="text-warning" v-if="$v.form.email.$error">
					Please enter a valid email. Eg: @gmail.com, @yahoo.com, etc.
				</small>
			</b-form-group>
			<b-form-group label="Password" label-for="setpassword-password">
				<b-form-input
					id="setpassword-password"
					v-model="form.password"
					type="password"
					required
					placeholder="********"
				></b-form-input>
				<small class="text-warning" v-if="$v.form.password.$error">
					Please make sure your password is 8 characters or longer
				</small>
			</b-form-group>
			<b-form-group label="Account type">
				<b-form-radio
					v-for="type in account_types"
					v-model="form.account_type"
					:name="type.name"
					:value="type.key"
					:key="type.key"
				>
					<h4>{{ type.name }}</h4>
					<p>
						{{ type.description }}
					</p>
				</b-form-radio>
			</b-form-group>
			<b-form-group label="What features are you looking forward to?">
				<b-form-radio
					v-for="type in feature_types"
					v-model="form.feature_type"
					:name="type.name"
					:value="type.key"
					:key="type.key"
				>
					<h4>{{ type.name }}</h4>
					<p>
						{{ type.description }}
					</p>
				</b-form-radio>
			</b-form-group>
			<b-button
				type="submit"
				variant="primary"
				:class="[{ disabled: lock === true }]"
				>Signup<b-spinner :class="['ml-1']" small v-if="lock"></b-spinner
			></b-button>
			<div class="form-error" v-if="errorMessage">
				{{ errorMessage }}
			</div>
		</b-form>
	</div>
</template>

<script>
import { required, minLength, between } from 'vuelidate/lib/validators';
import emailValidator from '@/lib/email-validator.js';
export default {
	data: function () {
		return {
			lock: false,
			errorMessage: '',
			account_types: [
				{
					name: 'Educational',
					key: 'educational',
					description: "You're a student, teacher or a tutor.",
				},
				{
					name: 'Content creation',
					key: 'content_creation',
					description:
						"You're creating content via blogging, vlogging, newsletters, etc.",
				},
				{
					name: 'Other',
					key: '',
					description: '',
				},
			],
			feature_types: [
				{
					name: 'Text highlights',
					key: 'text_highlights',
					description: 'I want to take text highlights',
				},
				{
					name: 'PDF highlights',
					key: 'pdf_highlights',
					description: 'I want to save highlights inside PDF files',
				},
				{
					name: 'Bookmarkings',
					key: 'bookmarks',
					description: 'I want to save bookmarks',
				},
				{
					name: 'Other',
					key: 'other',
					description: ``,
				},
			],
			form: {
				name: '',
				email: '',
				password: '',
				account_type: '',
				feature_type: '',
				source: 'webapp',
			},
		};
	},
	validations: {
		form: {
			name: {
				required,
			},
			email: {
				required,
				//emailValidator,
			},
			password: {
				required,
				minLength: minLength(8),
			},
		},
	},
	methods: {
		reset: function () {
			this.form = {
				name: '',
				email: '',
				password: '',
				account_type: '',
				feature_type: '',
				source: 'webapp',
			};
		},
		signup: function (data) {
			this.$store.dispatch('user/setToken', data);
			this.$store.dispatch('user/afterLogin', null, { root: true });
			this.$store.commit('user/SET_AFTER_SIGNUP', null, { root: true });
		},
		error: function () {
			this.errorMessage = `We couldn't sign you up. Please try with a valid email. Avoid using burner emails.`;
		},
		submit: function () {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.lock = true;
				this.$store
					.dispatch('user/signup', this.form)
					.then((data) => {
						setTimeout(() => {
							this.lock = false;
							if (data) {
								this.signup(data);
								this.$emit('onSuccess');
								this.reset();
							} else {
								this.error();
							}
						}, 1000);
					})
					.catch((err) => {
						this.lock = false;
						this.error();
					});
			}
		},
	},
};
</script>

<style lang="scss">
.form-signup {
	.custom-radio {
		background-color: rgba(0, 0, 0, 0.15);
		padding: 0.5rem;
		padding-left: 36px;
		border-radius: 8px;
		margin-bottom: 1rem;
	}
	.custom-control-label {
		width: 100%;
		h4 {
			margin-bottom: 0.2rem;
		}
		&:before {
			left: -26px;
		}
		&:after {
			left: -26px;
		}
		p {
			margin: 0;
		}
	}

	.spinner-border {
		margin-left: var(--margin-sm);
	}
}
</style>
